export const downloadFile = (component, url, fileName='', params = {}) => {
  component.$axios
    .get(url, { responseType: 'blob', params: params })
    .then((response) => {
      const blob = new Blob([response.data]);
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = response.headers['x-suggested-filename'] || fileName;
      link.click();
      link.remove();
    })
    .catch((error) => {
      try {
        component.$notify({
          duration: 5000,
          text: error.response.statusText || error.response,
          ignoreDuplicates: true,
        });
      } catch (e) {}
    });
};

export const urlWhereToBuy = async (axios) => {
    const page_wtb = await axios.$get('/pages/', {params: {slug: 'gde-kupit'}, count_loading: true});
    const url = new URL(page_wtb.items[0]?.meta.html_url)
    return url.pathname
}
